'use client';
import { createContext, useContext, useState } from 'react';
import type { CurrencyDisplay } from './types';

const CURRENCY_COOKIE = 'uqhoan_currency';
export const DEFAULT_CURRENCY_CODE = 'ILS';

type CurrencyContextValue = {
  currency: CurrencyDisplay;
  setCurrency: (c: CurrencyDisplay) => void;
  activeCurrencies: CurrencyDisplay[];
};

const CurrencyContext = createContext<CurrencyContextValue | null>(null);

export function CurrencyProvider({
  children,
  activeCurrencies,
  initialCode,
}: {
  children: React.ReactNode;
  activeCurrencies: CurrencyDisplay[];
  initialCode: string;
}) {
  const initial = activeCurrencies.find((c) => c.code === initialCode)
    ?? activeCurrencies.find((c) => c.code === DEFAULT_CURRENCY_CODE)
    ?? activeCurrencies[0];

  const [currency, setCurrencyState] = useState<CurrencyDisplay>(initial);

  function setCurrency(c: CurrencyDisplay) {
    setCurrencyState(c);
    document.cookie = `${CURRENCY_COOKIE}=${c.code}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
  }

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, activeCurrencies }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error('useCurrency must be used inside CurrencyProvider');
  return ctx;
}
